import { ChipVariant } from '../Chip';
import { CardStatus } from './TundrCard.types';

export const getCardVariantFromStatus = (status: CardStatus) => {
  switch (status) {
    case CardStatus.ACTIVATED:
      return ChipVariant.SUCCESS;
    case CardStatus.TO_ACTIVATE:
      return ChipVariant.INFO;
    case CardStatus.CANCELED:
      return ChipVariant.ERROR;
    case CardStatus.SUSPENDED:
      return ChipVariant.ERROR;
    case CardStatus.TO_ORDER:
      return ChipVariant.LIGHT;
    default:
      return ChipVariant.LIGHT;
  }
};

export const showCardDigits = (
  showCardNumbers: boolean,
  cardMaskedNumber?: string,
): string => {
  const hiddenNumbers = '**** **** **** ****';
  const maskedNumberLength = cardMaskedNumber?.length ?? 0;

  const numbersToBeDisplayed = cardMaskedNumber
    ? `**** **** **** ${cardMaskedNumber.substring(
        maskedNumberLength - 4,
        maskedNumberLength,
      )}`
    : hiddenNumbers;
  return showCardNumbers ? numbersToBeDisplayed : hiddenNumbers;
};
